export default __webpack_public_path__ + "static/media/ai_mobile.6e7a2fd2b6caee2e532b00320e337a9f.svg";